'use client'

import { useMemo } from 'react'

import type { ProjectResourceGroup } from '@modules/project-keys/project-keys.interface'

import { buildGatewayListFilterOptionSets } from '../domain/buildGatewayListFilterOptionSets'
import type { GatewayListFilterFormSlice, GatewayListFilterTraitsSource } from '../types/gatewayListFilters.types'

export function useGatewayListFilterOptionSets(
  sources: GatewayListFilterTraitsSource[],
  filters: Pick<GatewayListFilterFormSlice, 'status' | 'runtime' | 'feed' | 'projectKey'>,
  projectKeyGroups: ProjectResourceGroup[] = []
) {
  return useMemo(
    () => buildGatewayListFilterOptionSets(sources, filters, projectKeyGroups),
    [filters, projectKeyGroups, sources]
  )
}
